import {createSlice} from '@reduxjs/toolkit';

import {couponBuilder} from './reducer';

type CouponItem = {
  id: number;
  title: string;
  description: string;
  status: string;
  start_time: string;
  end_time: string;
};

type TemplateItem = {
  id: number;
  title: string;
  description: string;
  reward_mode: string;
};

export type CouponState = {
  loading: boolean;
  historyList: {
    coupons: CouponItem[];
    page: number;
    size: number;
    total_items: number;
    total_pages: number;
  } | null;
  details: {
    id: number;
    title: string;
    description: string;
    status: string;
    start_time: string;
    end_time: string;
  } | null;
  templateList: {
    templates: TemplateItem[];
    page: number;
    page_size: number;
  } | null;
  create: {
    loading: boolean;
  };
  remove: {
    loading: boolean;
  };
  pause: {
    loading: boolean;
  };
};

const initialState: any = {
  loading: false,
  historyList: {
    coupons: [],
    page: 1,
    size: 10,
    total_items: 0,
    total_pages: 0
  },
  details: null,
  templateList: {
    templates: [],
    page: 1,
    page_size: 10
  },
  create: {
    loading: false
  },
  remove: {
    loading: false
  },
  pause: {
    loading: false
  }
};

export const couponSlicer = createSlice({
  name: 'coupon',
  initialState,
  reducers: {},
  extraReducers: couponBuilder
});

export default couponSlicer.reducer;
